import React, { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import NetworkPrintErrorModal from '../../../VNTabs/components/NetworkPrintErrorModal'
import { getPrinterUnavailableOfflineDialogOpen, getPrinterUnavailableOfflineDialogType } from '../../Selectors'
import { setPrinterUnavailableOfflineDialog } from '../../ActionCreators'

/**
 * Modal for when attempting to print to cloud printer while offline
 *
 * @link https://www.figma.com/design/c2daBWS1vGCMSVb1zfSQpO/Quick-Service?node-id=13407-56149
 * @returns {React.Element}
 */
export const VNCloudPrinterUnavailableOffline = () => {
  const dispatch = useDispatch()
  const isOpen = useSelector(getPrinterUnavailableOfflineDialogOpen)
  const type = useSelector(getPrinterUnavailableOfflineDialogType)

  const cancelHandler = useCallback(() => {
    dispatch(setPrinterUnavailableOfflineDialog(false))
  }, [dispatch])

  if (!isOpen) {
    return null
  }

  // TODO: refactor component to use VNDialogs with equivalent styling
  return <NetworkPrintErrorModal onCancel={cancelHandler} type={type} />
}
